import { AnyAction } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, takeLatest } from 'redux-saga/effects';
import { getCountries } from 'src/api/country';
import { FETCH_COUNTRIES, requestCountries, requestCountriesFailure, requestCountriesSuccess } from './actions';

function* fetchCountriesSaga(action: AnyAction): SagaIterator {
    yield put(requestCountries());

    const { error, response } = yield call(getCountries);

    if (error) {
        yield put(requestCountriesFailure(error));
    } else {
        yield put(requestCountriesSuccess(response));
    }
}

export function* generateFetchCountriesWatcher() {
    yield takeLatest(FETCH_COUNTRIES, fetchCountriesSaga);
}
